module.exports = __webpack_public_path__ + "static/img/blog.3bff5ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog.png
// module id = v+3t
// module chunks = 1